import { render, staticRenderFns } from "./Selector.vue?vue&type=template&id=b48a4d62&scoped=true&"
import script from "./Selector.vue?vue&type=script&lang=js&"
export * from "./Selector.vue?vue&type=script&lang=js&"
import style0 from "./Selector.vue?vue&type=style&index=0&id=b48a4d62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48a4d62",
  null
  
)

export default component.exports